import Cards from "../Cards/Cards";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getAllDogs, getAllTemps } from "../../redux/actions/index"; //eslint-disable-line

const Home = () => {
  const dispatch = useDispatch(); //eslint-disable-line
  const { lenguage } = useSelector((s) => s);
  useEffect(() => {
    dispatch(getAllDogs());
    dispatch(getAllTemps());
  }, []); //eslint-disable-line
  return (
    <>
      <div className="home_container">
        <br />
        <h1>{lenguage ? "Home" : "Inicio"}</h1>
        <Cards />
      </div>
    </>
  );
};

export default Home;
